import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons

import Email from "@material-ui/icons/Email";
import People from "@material-ui/icons/People";

import Person from "@material-ui/icons/Person";
import PhoneAndroid from "@material-ui/icons/PhoneAndroid"
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Datetime from "react-datetime";
import Button from "components/CustomButtons/Button.js";

import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import moment from 'moment';

import styles from "assets/jss/material-kit-react/views/loginPage.js";
import url from '../../link'

import image from "assets/img/9440.jpg";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { FormatAlignCenter } from "@material-ui/icons";
import Slide from "@material-ui/core/Slide";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import TextField from '@material-ui/core/TextField';
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


export default function Fast_Track_Registration(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  const [classicModal, setClassicModal] = React.useState(false);
  const [firstName,setFirstName]= React.useState('')
  const [lastName,setLastName]= React.useState('')
  const [title,setTitle]= React.useState('Select')
  const [gender,setGender]= React.useState('Select')
  const [email,setEmail]= React.useState('')
  const [age,setAge]= React.useState(0)
  const [Date_Birth,setDate_Birth]=React.useState('')
  const [MobileNumber,setMobileNumber]= React.useState('')
  const [network , setNetwork]= React.useState('Select')
  const [passport,setPassport]=React.useState('')
  const [ServerResponse, setServerResponse]=React.useState('')
  const [AirLine ,setAirLine]=React.useState('Select')
  const [FlightNo,setFlightNo]=React.useState('')
  const [FlightDate,setFlightDate]=React.useState('')
  const [TicketNo,setTicketNo]=React.useState('')
  const [Country,setCountry]=React.useState('Select')
  const [Airport,setAirport]=React.useState('Select')
  const [CNIC ,setCNIC]=React.useState('')
  const [city,setCity]=React.useState('')
  const [address,setAddress]=React.useState('')
  const yesterday = moment().subtract(1, 'day');
const disablePastDt = current => {
  return current.isAfter(yesterday);
};
  const all_countries=["Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegowina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia (Hrvatska)", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "France Metropolitan", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard and Mc Donald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao, People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia (Slovak Republic)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Sri Lanka", "St. Helena", "St. Pierre and Miquelon", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Yugoslavia", "Zambia", "Zimbabwe"]
  const all_city=["Abbottabad",
  "Adezai",
  "Ali Bandar",
  "Amir Chah",
  "Attock",
  "Ayubia",
  "Bahawalpur",
  "Baden",
  "Bagh",
  "Bahawalnagar",
  "Burewala",
  "Banda Daud Shah",
  "Bannu district|Bannu",
  "Batagram",
  "Bazdar",
  "Bela",
  "Bellpat",
  "Bhag",
  "Bhakkar",
  "Bhalwal",
  "Bhimber",
  "Birote",
  "Buner",
  "Burj",
  "Chiniot",
  "Chachro",
  "Chagai",
  "Chah Sandan",
  "Chailianwala",
  "Chakdara",
  "Chakku",
  "Chakwal",
  "Chaman",
  "Charsadda",
  "Chhatr",
  "Chichawatni",
  "Chitral",
  "Dadu",
  "Dera Ghazi Khan",
  "Dera Ismail Khan",
   "Dalbandin",
  "Dargai",
  "Darya Khan",
  "Daska",
  "Dera Bugti",
  "Dhana Sar",
  "Digri",
  "Dina City|Dina",
  "Dinga",
  ", Pakistan|Diplo",
  "Diwana",
  "Dokri",
  "Drosh",
  "Duki",
  "Dushi",
  "Duzab",
  "Faisalabad",
  "Fateh Jang",
  "Ghotki",
  "Gwadar",
  "Gujranwala",
  "Gujrat",
  "Gadra",
  "Gajar",
  "Gandava",
  "Garhi Khairo",
  "Garruck",
  "Ghakhar Mandi",
  "Ghanian",
  "Ghauspur",
  "Ghazluna",
  "Girdan",
  "Gulistan",
  "Gwash",
  "Hyderabad",
  "Hala",
  "Haripur",
  "Hab Chauki",
  "Hafizabad",
  "Hameedabad",
  "Hangu",
  "Harnai",
  "Hasilpur",
  "Haveli Lakha",
  "Hinglaj",
  "Hoshab",
  "Islamabad",
  "Islamkot",
  "Ispikan",
  "Jacobabad",
  "Jamshoro",
  "Jhang",
  "Jhelum",
  "Jamesabad",
  "Jampur",
  "Janghar",
  "Jati(Mughalbhin)",
  "Jauharabad",
  "Jhal",
  "Jhal Jhao",
  "Jhatpat",
  "Jhudo",
  "Jiwani",
  "Jungshahi",
  "Karachi",
  "Kotri",
  "Kalam",
  "Kalandi",
  "Kalat",
  "Kamalia",
  "Kamararod",
  "Kamber",
  "Kamokey",
  "Kanak",
  "Kandi",
  "Kandiaro",
  "Kanpur",
  "Kapip",
  "Kappar",
  "Karak City",
  "Karodi",
  "Kashmor",
  "Kasur",
  "Katuri",
  "Keti Bandar",
  "Khairpur",
  "Khanaspur",
  "Khanewal",
  "Kharan",
  "kharian",
  "Khokhropur",
  "Khora",
  "Khushab",
  "Khuzdar",
  "Kikki",
  "Klupro",
  "Kohan",
  "Kohat",
  "Kohistan",
  "Kohlu",
  "Korak",
  "Korangi",
  "Kot Sarae",
  "Kotli",
  "Lahore",
  "Larkana",
  "Lahri",
  "Lakki Marwat",
  "Lasbela",
  "Latamber",
  "Layyah",
  "Leiah",
  "Liari",
  "Lodhran",
  "Loralai",
  "Lower Dir",
  "Shadan Lund",
  "Multan",
  "Mandi Bahauddin",
  "Mansehra",
  "Mian Chanu",
  "Mirpur",
  ", Pakistan|Moro",
  "Mardan",
  "Mach",
  "Madyan",
  "Malakand",
  "Mand",
  "Manguchar",
  "Mashki Chah",
  "Maslti",
  "Mastuj",
  "Mastung",
  "Mathi",
  "Matiari",
  "Mehar",
  "Mekhtar",
  "Merui",
  "Mianwali",
  "Mianez",
  "Mirpur Batoro",
  "Mirpur Khas",
  "Mirpur Sakro",
  "Mithi",
  "Mongora",
  "Murgha Kibzai",
  "Muridke",
  "Musa Khel Bazar",
  "Muzaffar Garh",
  "Muzaffarabad",
  "Nawabshah",
  "Nazimabad",
  "Nowshera",
  "Nagar Parkar",
  "Nagha Kalat",
  "Nal",
  "Naokot",
  "Nasirabad",
  "Nauroz Kalat",
  "Naushara",
  "Nur Gamma",
  "Nushki",
  "Nuttal",
  "Okara",
  "Ormara",
  "Peshawar",
  "Panjgur",
  "Pasni City",
  "Paharpur",
  "Palantuk",
  "Pendoo",
  "Piharak",
  "Pirmahal",
  "Pishin",
  "Plandri",
  "Pokran",
  "Pounch",
  "Quetta",
  "Qambar",
  "Qamruddin Karez",
  "Qazi Ahmad",
  "Qila Abdullah",
  "Qila Ladgasht",
  "Qila Safed",
  "Qila Saifullah",
  "Rawalpindi",
  "Rabwah",
  "Rahim Yar Khan",
  "Rajan Pur",
  "Rakhni",
  "Ranipur",
  "Ratodero",
  "Rawalakot",
  "Renala Khurd",
  "Robat Thana",
  "Rodkhan",
  "Rohri",
  "Sialkot",
  "Sadiqabad",
  "Safdar Abad- (Dhaban Singh)",
  "Sahiwal",
  "Saidu Sharif",
  "Saindak",
  "Sakrand",
  "Sanjawi",
  "Sargodha",
  "Saruna",
  "Shabaz Kalat",
  "Shadadkhot",
  "Shahbandar",
  "Shahpur",
  "Shahpur Chakar",
  "Shakargarh",
  "Shangla",
  "Sharam Jogizai",
  "Sheikhupura",
  "Shikarpur",
  "Shingar",
  "Shorap",
  "Sibi",
  "Sohawa",
  "Sonmiani",
  "Sooianwala",
  "Spezand",
  "Spintangi",
  "Sui",
  "Sujawal",
  "Sukkur",
  "Suntsar",
  "Surab",
  "Swabi",
  "Swat",
  "Tando Adam",
  "Tando Bago",
  "Tangi",
  "Tank City",
  "Tar Ahamd Rind",
  "Thalo",
  "Thatta",
  "Toba Tek Singh",
  "Tordher",
  "Tujal",
  "Tump",
  "Turbat",
  "Umarao",
  "Umarkot",
  "Upper Dir",
  "Uthal",
  "Vehari",
  "Veirwaro",
  "Vitakri",
  "Wadh",
  "Wah Cantt",
  "Warah",
  "Washap",
  "Wasjuk",
  "Wazirabad",
  "Yakmach",
  "Zhob"]
  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});
  const [otherCity,setOtherCity]=React.useState('')
  setTimeout(function() {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        absolute
        color="transparent"
        brand="Material Kit React"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className={classes.container}>
          
              <Card className={classes[cardAnimaton]}>
                <form className={classes.form}>
                  <CardHeader  className={classes.cardHeader} style={{backgroundColor:'#1a5790'}}>
                    <h4 style={{color:'white'}}>Fast Track Registration</h4>
                    
                  </CardHeader>
                  <CardBody>
                      <GridContainer>
                      <GridItem xs={12} xs={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="First Name"
                  value={firstName}
                  onChange={(e)=>{
                    setFirstName(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                  <GridItem xs={0} sm={0} md={4} lg={4}>
                      </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                  <TextField required id="" block
                  fullWidth={true}
                  label="Last Name"
                  value={lastName}
                  onChange={(e)=>{
                    setLastName(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                  
                  </GridContainer>
                  <br />
                  <GridContainer>
                  <GridItem xs={12} sm={12} md={4} lg={4}>
                     
                  
                    <TextField required id="" block
                  fullWidth={true}
                  type="text"
                  label="Passport No."
                  value={passport}
                  onChange={(e)=>{
                    setPassport(e.target.value)
                  }} 
                  
                  />
    </GridItem>
    <GridItem xs={0} sm={0} md={4} lg={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4} lg={4}>
        <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">AirLine</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={AirLine}
          onChange={(e)=>{
       setAirLine(e.target.value)
          }}
        >
          <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
         
          <MenuItem value={"Qatar Airways"}>Qatar Airways</MenuItem>
          
          <MenuItem value={"Airblue"}>Airblue</MenuItem>
          <MenuItem value={"Etihad Airways"}>Etihad Airways</MenuItem>
          <MenuItem value={"Emirates"}>Emirates</MenuItem>
          <MenuItem value={"Flydubai"}>Flydubai</MenuItem>
          <MenuItem value={"Air Arabia"}>Air Arabia</MenuItem>
          <MenuItem value={"Turkish Airlines"}>Turkish Airlines</MenuItem>
          <MenuItem value={"SereneAir"}>SereneAir</MenuItem>
          <MenuItem value={"PIA"}>PIA</MenuItem>
         

          
        </Select>
      </FormControl>
        </GridItem>
        </GridContainer>
        <br />
        <GridContainer>
            <GridItem xs={12} sm={12} md={4} lg={4}>
                  <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">Title</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={title}
          onChange={(e)=>{
       setTitle(e.target.value)
          }}
        >
          <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
         
          <MenuItem value={"Mr."}>Mr.</MenuItem>
          
          <MenuItem value={"Miss"}>Miss</MenuItem>
          <MenuItem value={"Mrs."}>Mrs.</MenuItem>
          <MenuItem value={"Baby"}>Baby</MenuItem>
          <MenuItem value={"Master"}>Master</MenuItem>
          <MenuItem value={"Sir"}>Sir</MenuItem>
          <MenuItem value={"Madam"}>Madam</MenuItem>
          <MenuItem value={"C/O"}>C/O</MenuItem>
          <MenuItem value={"B/O"}>B/O</MenuItem>
          <MenuItem value={"W/O"}>W/O</MenuItem>
          <MenuItem value={"D/O"}>D/O</MenuItem>
          <MenuItem value={"S/O"}>S/O</MenuItem>
          <MenuItem value={"H/O"}>H/O</MenuItem>
          <MenuItem value={"M/O"}>M/O</MenuItem>
          <MenuItem value={"Dr.-"}>Dr.</MenuItem>

          
        </Select>
      </FormControl>
      </GridItem>
      <GridItem xs={0} sm={0} md={4} lg={4}>
      </GridItem>
      <GridItem xs={12} sm={12} md={4} lg={4}>
      <TextField required id="" block
                  fullWidth={true}
                  label="Flight No"
                  type="text"
                  value={FlightNo}
                  onChange={(e)=>{
                    setFlightNo(e.target.value)
                  }} 
                  
                  />
          </GridItem>
          </GridContainer>
          <br />
<GridContainer>
    <GridItem xs={12} sm={12} md={4} lg={4}>
      <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">Gender</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={gender}
          onChange={(e)=>{
       setGender(e.target.value)
          }}
        >
        <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
          <MenuItem value={"Male"}>Male</MenuItem>
          <MenuItem value={"Female"}>Female</MenuItem>
        </Select>
      </FormControl>
      </GridItem>
      <GridItem xs={0} sm={0} md={4} lg={4}>
          </GridItem>
          <GridItem xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
                    <Datetime
                      inputProps={{ placeholder: "Flight Date" }}
                      value={FlightDate}
                      isValidDate={disablePastDt}
                      required
                      timeFormat=""
                      onChange={(e)=>{
                          console.log(e)
                          setFlightDate(e)
                      }}
                    />
                  </FormControl>
              </GridItem>
              </GridContainer>
     <br />
     <GridContainer>
         <GridItem xs={12} sm={12} md={4} lg={4} >
      <TextField required id="" block
                  fullWidth={true}
                  label="Email"
                  value={email}
                  onChange={(e)=>{
                    setEmail(e.target.value)
                  }} 
                  
                  />
                  </GridItem>
                  <GridItem xs={0} sm={0} md={4} lg={4} >
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4} lg={4} >
                      <TextField required id="" block
                  fullWidth={true}
                  label="Ticket No. / PNRA"
                  value={TicketNo}
                  onChange={(e)=>{
                    setTicketNo(e.target.value)
                  }} 
                  
                  />
                      </GridItem>
                      </GridContainer>
                      <br />
                      <GridContainer>
         <GridItem xs={12} sm={12} md={4} lg={4} >
         <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">Country</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={Country}
          onChange={(e)=>{
       setCountry(e.target.value)
          }}
        >
        <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
         
         {all_countries.map((item)=>{
 return <MenuItem value={item} key={item}>{item}</MenuItem>
         })}
        </Select>
      </FormControl>
                  </GridItem>
                  <GridItem xs={0} sm={0} md={4} lg={4} >
                      </GridItem>
                      <GridItem xs={12} sm={12} md={4} lg={4} >
                      <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">Airport</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={Airport}
          onChange={(e)=>{
       setAirport(e.target.value)
          }}
        >
        <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
        <MenuItem  value={"Islamabad International Airport"}>Islamabad International Airport</MenuItem>
        <MenuItem  value={"Lahore Allama Iqbal International Airport"}>Lahore Allama Iqbal International Airport</MenuItem>

        <MenuItem  value={"Dera Ghazi Khan International Airport"}>Dera Ghazi Khan International Airport</MenuItem>
        <MenuItem  value={"Faisalabad International Airport"}>Faisalabad International Airport</MenuItem>
        <MenuItem  value={"Gwadar International Airport"}>Gwadar International Airport</MenuItem>
        <MenuItem  value={"Multan International Airport"}>Multan International Airport</MenuItem>
        <MenuItem  value={"Peshawar Bacha Khan International Airport"}>Peshawar Bacha Khan International Airport</MenuItem>
        <MenuItem  value={"Quetta International Airport"}>Quetta International Airport</MenuItem>
        <MenuItem  value={"Shaikh Zayed International Airport"}>Shaikh Zayed International Airport</MenuItem>
        <MenuItem  value={"Sialkot International Airport"}>Sialkot International Airport</MenuItem>
        <MenuItem  value={"Turbat International Airport"}>Turbat International Airport</MenuItem>
        <MenuItem  value={"Bahawalpur Airport"}>Bahawalpur Airport</MenuItem>
        </Select>
      </FormControl>
                      </GridItem>
                      </GridContainer>
<br />
                      <GridContainer>
                          <GridItem xs={12} sm={12} md={4} lg={4}>
                         {
                        Country =="Pakistan" ?
                        <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">City</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={city}
          onChange={(e)=>{
       setCity(e.target.value)
          }}
        >
        <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
        {all_city.map((item)=>{
 return <MenuItem value={item} key={item}>{item}</MenuItem>
         })}
        </Select>
      </FormControl>:
      <TextField required id="" block
      fullWidth={true}
      label="City"
      value={otherCity}
      type="text"
      onChange={(e)=>{
        var age=e.target.value
        setCity(age)
       } }
      
      />

                    }
                              </GridItem>
                              <GridItem xs={0} sm={0} md={4} lg={4}>
                              </GridItem>
                              <GridItem xs={12} sm={12} md={4} lg={4}>
                              <TextField required id="" block
                  fullWidth={true}
                  label="CNIC"
                  placeholder="XXXXXXXXXXXXX"
                  value={CNIC}
                  type="number"
                  onChange={(e)=>{
                    var age=e.target.value
                    setCNIC(age)
                   } }
                  
                  />
                              </GridItem>
</GridContainer>
<br />
                   <GridContainer>
                       <GridItem xs={12} sm={12} md={4} lg={4}>
 <Datetime
                      inputProps={{ placeholder: "Date of Birth" }}
                      value={Date_Birth}
                      timeFormat=""
                      required
                      onChange={(e)=>{
                          setDate_Birth(e)
                      }}
                    />
                       </GridItem>
                       <GridItem xs={0} sm={0} md={4} lg={4}>
                           </GridItem>
                           <GridItem xs={12} sm={12} md={4} lg={4}>
                           <TextField required id="" block
                  fullWidth={true}
                  type="text"
                  label="Address"
                  value={address}
                  onChange={(e)=>{
                      console.log(e.target.value)
                    setAddress(e.target.value)
                  }} 
                  multiline={3}
                  
                  />
                           </GridItem>
                           
                       </GridContainer>
                     <br />
                     <GridContainer>
                         <GridItem xs={12} sm={12} md={4} lg={4}>
                         <FormControl variant="filled" className={classes.formControl}  style={{width:"-webkit-fill-available"}} >
        <InputLabel id="demo-simple-select-filled-label">Mobile Network</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={network}
        
          onChange={(e)=>{
            setNetwork(e.target.value)
          }}
        >
           <MenuItem disabled={true} value={"Select"}>Select</MenuItem>
          <MenuItem value={"Ufone"}>Ufone</MenuItem>
          <MenuItem value={"Zong"}>Zong</MenuItem>
          <MenuItem value={"Mobilink"}>Mobilink</MenuItem>
          <MenuItem value={"Telenor"}>Telenor</MenuItem>
          <MenuItem value={"Warid"}>Warid</MenuItem>
        </Select>
      </FormControl>
                         </GridItem>
                         <GridItem xs={0} sm={0} md={4} lg={4}>

                         </GridItem>
                         <GridItem xs={12} sm={12} md={4} lg={4}>
                         <TextField required id="" block
                  fullWidth={true}
                  type="number"
                  label="Mobile Number"
                  value={MobileNumber}
                  placeholder="XXXXXXXXXXX"
                  onChange={(e)=>{
                    setMobileNumber(e.target.value)
                  }} 
                  
                  />
                         </GridItem>
                         </GridContainer>
                         <br />
                    <GridContainer>
                       
                        <GridItem xs={12} sm={12} md={4} lg={4}>
                        <b>Kindly Upload Image the Following Document for this Panel</b>
                            <ul>
                                <li>Copy of Airline ticket</li>
                                <li>Passport Copy</li>
                                <li>CNIC for Pakistani National</li>
                                <li>Other Mandatory Pictures</li>
                                </ul>
                        <Button color="#1a5790" size="lg" style={{backgroundColor:'#1a5790'}} >
                           
                        <input type="file"  accept="image/*" id="file" multiple />
                        </Button>
                        </GridItem>
                    </GridContainer>
      

                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    <Button color="#1a5790" size="lg" style={{backgroundColor:'#1a5790'}}
                     onClick={async()=>{
                       var number=MobileNumber+""
                       var cnic=CNIC+""
                       var totalfiles = document.getElementById('file').files.length;
                       var images=[]
                        for (var index = 0; index < totalfiles; index++) {
                          var image=document.getElementById('file').files[index]
                          images.push(image)
                         }
                         var doc=[]
                        var data=await images.map(async(item)=>{
                          var image= await toBase64(item)
                          var send_image=image.split('data:image/png;base64,')
                          doc.push(send_image[1])
                          return doc
                         })
                         Promise.all(data).then((res)=>{
                            console.log(doc)
                         })
                         
                    
                    
                      if(firstName.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter First Name !!')
                        return
                       }
                       if(lastName.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter Last Name !!')
                        return
                       }
                       if(gender=='Select'){
                        setClassicModal(true)
                        setServerResponse('Kindly Select Gender !!')
                        return
                       }
                       if(number.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter Mobile Number !!')
                        return
                       }
                       if(network=='Select'){
                        setClassicModal(true)
                        setServerResponse('Kindly Select Network!!')
                        return
                       }
                       if(email.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Kindly Enter Email Address !!')
                        return
                       }
                       if(title=='Select'){
                        setClassicModal(true)
                        setServerResponse('Kindly Select Title !!')
                        return
                       }
                       if(Date_Birth==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Date of Birth!!')
                        return
                       }
                       if(passport.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Passport!')
                        return
                       }
                       if(FlightNo.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Flight Number!')
                        return
                       }
                       if(FlightDate==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Flight Date!')
                        return
                       }
                       if(TicketNo.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Ticket No / PNRA !')
                        return
                       }
                       if(Country=='Select'){
                        setClassicModal(true)
                        setServerResponse('Invalid Country!')
                        return
                       }
                       if(Airport=='Select'){
                        setClassicModal(true)
                        setServerResponse('Invalid Airport!')
                        return
                       }
                       if(Country=='Pakistan' && city=='Select'){
                        setClassicModal(true)
                        setServerResponse('Invalid City!')
                        return
                       }
                       if(Country!='Pakistan' && otherCity==''){
                        setClassicModal(true)
                        setServerResponse('Invalid City!')
                        return
                       }
                       if(cnic.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid CNIC !')
                        return
                       }
                       if(address.trim()==''){
                        setClassicModal(true)
                        setServerResponse('Invalid Address !')
                        return
                       }
                       
                       if(AirLine=='Select'){
                        setClassicModal(true)
                        setServerResponse('Invalid AirLine!')
                        return
                       }
                       if(totalfiles<3){
                        setClassicModal(true)
                        setServerResponse('Kindly Upload Require 3 Type of Files!')
                        return
                       }
                      
                    //    fetch('https://eviewer.fslabs.com.pk/4DACTION/WebPortal_RegisterPatient_WS?first_name='+firstName+'&last_name='+lastName+'&email='+email+'&birth_date='+birth_date+'&network='+network+'&gender='+gender+'&to_address='+title+'&M_Status=Single&mobile_number='+number).then((response) => {
                    //       return response.text();
                    //    }).then((res)=>{
                    //      console.log(res) 
                    //     if(res=="Successful"){
                    //       setClassicModal(true)
                    //       setServerResponse('Patient Account Created, Kindly Check Email for Credentails!!')
                    //       setTimeout(()=>{
                    //         window.location.reload()
                    //       },3500)
                    //       setTimeout(() => {
                    //         window.location.href=url+"/Login"
                    //       }, 3000);
                    //     return
                    //     }
                    //     else if(res=="Failure"){
                    //       setClassicModal(true)
                    //       setServerResponse('Sorry , Registration Failed!!')
                    //       return
                      
                    //      }
                    //     else{
                    //       setClassicModal(true)
                    //       setServerResponse('Patient Already Exists!!!')
                    //       return
                      
                    //     }
                    //   })
                       
                       
                     }}
                    >
                      Register
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            
         
          <GridContainer>
              <GridItem xs={12} sm={12} md={6} lg={4}>

            <Dialog
                  classes={{
                    root: classes.center,
                    paper: classes.modal
                  }}
                  open={classicModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => setClassicModal(false)}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                  >
                   
                    <h4 className={classes.modalTitle}><b>Patient Registration</b></h4>
                  </DialogTitle>
                  <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                  >
                    <p>
                      {ServerResponse}
                    </p>
                  </DialogContent>
                  <DialogActions className={classes.modalFooter}>
                   
                    <Button
                      onClick={() => setClassicModal(false)}
                      color="danger"
                      simple
                    >
                      Ok
                    </Button>
                  </DialogActions>
                </Dialog>
              </GridItem>
          </GridContainer>

        </div>
       
      </div>
    </div>
  );
}
